import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { closeOrderItemTime } from "../../../../../services/Admin/OrdersApi";
import { formatTime12Hour } from "../../../../../utils/dateTimeFormat";

const CloseItemTimePrepration = ({ open, onClose, item, onClosed }) => {
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState("");

	const handleClose = async () => {
		setError("");

		// Validation
		if (!item?.id) {
			setError("معرف العنصر مطلوب");
			return;
		}

		setSubmitting(true);
		try {
			const res = await closeOrderItemTime(item.id);

			// Success: notify parent and close
			onClosed && onClosed(res?.data || null);
			onClose();
		} catch (err) {
			setError(err?.message || "فشل إنهاء وقت التجهيز");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Dialog 
			open={Boolean(open)} 
			onClose={onClose} 
			maxWidth="xs" 
			fullWidth
		>
			<DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<CheckCircleIcon color="success" />
				تأكيد إنهاء التجهيز
			</DialogTitle>

			<DialogContent dividers>
				{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

				<Box sx={{ py: 2 }}>
					<Typography variant="body1" sx={{ mb: 2 }}>
						هل أنت متأكد من إنهاء وقت تجهيز هذا الصنف؟
					</Typography>

					{item && (
						<Box 
							sx={{ 
								p: 2, 
								bgcolor: 'success.50', 
								borderRadius: 1,
								border: "1px solid",
								borderColor: "success.200"
							}}
						>
							{/* Product or Drink Name */}
							{(item.product?.name || item.drinks?.drink_name || item.drinks?.name) && (
								<Typography variant="subtitle2" sx={{ mb: 0.5 }}>
									<strong>الصنف:</strong> {
										item.product?.name || 
										item.drinks?.drink_name || 
										item.drinks?.name ||
										`عنصر #${item.id}`
									}
								</Typography>
							)}
							
							{item.quantity && (
								<Typography variant="body2" sx={{ mb: 0.5 }}>
									<strong>الكمية:</strong> {item.quantity}
								</Typography>
							)}
							
							{item.price && (
								<Typography variant="body2" sx={{ mb: 0.5 }}>
									<strong>السعر:</strong> {item.price} ج.م
								</Typography>
							)}
							
							{item.open_time && (
								<Typography variant="body2" sx={{ mb: 0.5 }}>
									<strong>وقت البدء:</strong> {formatTime12Hour(item.open_time)}
								</Typography>
							)}
							
							{item.status && (
								<Typography variant="body2">
									<strong>الحالة الحالية:</strong> {item.status}
								</Typography>
							)}
						</Box>
					)}

					<Typography 
						variant="body2" 
						color="success.dark" 
						sx={{ mt: 2, fontWeight: "bold", display: "flex", alignItems: "center", gap: 0.5 }}
					>
						<CheckCircleIcon fontSize="small" />
						سيتم تسجيل وقت الإنهاء تلقائياً
					</Typography>
				</Box>
			</DialogContent>

			<DialogActions>
				<Button 
					onClick={onClose} 
					disabled={submitting}
					variant="outlined"
				>
					إلغاء
				</Button>
				<Button 
					onClick={handleClose} 
					variant="contained" 
					color="success"
					disabled={submitting}
				>
					{submitting ? <CircularProgress size={20} /> : "تأكيد الإنهاء"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CloseItemTimePrepration;
